/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TruckCabExtended = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 109 73" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M1.3 50.3c-.7.2-1.3.9-1.3 1.7v6.2c0 .9.8 1.7 1.7 1.7h15.9v-.8c0-3.1.8-6.1 2.4-8.8H1.3zM52.8 59.1v.8h55.7v-9.7H50.4c1.6 2.8 2.4 5.8 2.4 8.9zM65.4.8L43.9 20S4.5 22.4 4.5 36.3v.8h9.6c.8 0 1.4.7 1.4 1.4v1.3c0 .8-.7 1.4-1.4 1.4H4.5v5.9h18.1c6.5-7.2 17.7-7.7 24.8-1.1.4.4.8.7 1.1 1.1h60V.9L65.4.8zm19.2 28.5H73.8v-2.1h10.8v2.1zm.1-7.7H50.4L67.2 6.2h17.5v15.4zm17.6 0H91.1V6.4h11.2v15.2z" /><circle cx="35.3" cy="59" r="13.7" /></g>
      </g>
    </svg>
  </span>
);

TruckCabExtended.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TruckCabExtended.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TruckCabExtended;
